<template>
  <section class="text-remark pt-3">
    <div class="pb-2">
      ใช้ AI สกัดข้อมูลการจองจากข้อความ
    </div>
    <div class="pb-1 d-flex">
      <div class="flex-grow-1">
        <b>ข้อความ:</b>
      </div>
      <div class="text-right">
        <a href="" @click.prevent="clearMultiMessages()">ลบทั้งหมด</a>
      </div>
    </div>
    <div class="pb-2" :key="key" v-for="(message, key) in multiMessages">
      <div class="d-flex justify-content-start align-items-top rounded p-2" style="background-color: #ECEFF1;">
        <div class="flex-fill text-multi-messages">{{ message }}</div>
        <div class="pl-2 text-right">
          <a class="text-secondary" href="" @click.prevent="removeMultiMessages(key)">
            <i class="fa fa-circle-xmark"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="">
      <button class="btn btn-outline-info btn-block btn-sm" @click="submit()">
        ช่วยฉันวิเคราะห์
      </button>
    </div>
    <div class="mt-3" v-if="isLoading">
      <span>
        <i class="fa-solid fa-xl fa-compact-disc fa-flip"></i>&nbsp;&nbsp;AI กำลังประมวลผล...
      </span>
    </div>
    <div v-if="response">
      <hr>
      <div v-if="response.function_name === 'get_booking_value'">
        <booking :response="response" />
      </div>
      <div v-else-if="response.function_name === 'get_tax_invoice'">
        <tax-invoice :response="response" />
      </div>
      <div v-if="response.function_name === 'get_order_code'">
        <div>กดลิงค์เพื่อดูรายละเอียดการจอง #{{ response.params.order_code }}</div>
        <a :href="response.action_url" target="_blank">
          {{ response.action_url }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Booking from '@/components/aiAssistant/components/Booking'
import TaxInvoice from '@/components/aiAssistant/components/TaxInvoice'

export default {
  components: {
    Booking,
    TaxInvoice
  },
  data () {
    return {}
  },
  computed: {
    ...mapState('admin', ['admin']),
    ...mapState('aiAssistant', ['multiMessages', 'isLoading', 'response']),
    ...mapState('conversation', ['customer', 'customerType'])
  },
  methods: {
    ...mapActions('aiAssistant', ['callAiFunctionCalling']),
    clearMultiMessages () {
      this.$store.commit('aiAssistant/SET_RESPONSE', null)
      this.$store.commit('aiAssistant/CLEAR_MULTI_MESSAGES')
    },
    removeMultiMessages (key) {
      this.$store.commit('aiAssistant/REMOVE_ONE_OF_MULTI_MESSAGES', key)
    },
    submit () {
      if (this.customer && this.customer.customer) {
        const userInput = this.multiMessages.join(' ')
        const submitData = {
          beneat_user_id: this.customer.customer.id,
          user_input: userInput
        }
        this.callAiFunctionCalling(submitData)
      } else {
        this.$swal({
          text: 'วิเคราะห์ข้อมูลไม่ได้ เนื่องจากลูกค้ายังไม่ได้ลงทะเบียนเป็นสมาชิก',
          type: 'error'
        })
      }
    }
  }
}
</script>
